<template>
  <header class="header-pc">
    <div class="header-box">
      <div class="header-left">
        <img src="@/assets/images/logo.png" alt="" @click="changeNav({path: '/index'})">
      </div>
      <div class="header-right">
        <ul>
          <li v-for="item in $store.getters.useNavList" :key="item.key" :class="item.activated || (item.path === '/business' && ['/caidaoApp', '/shopkeeperHelp'].includes($route.path)) ? 'li--activated' : ''" @click="changeNav(item)">{{item.name}}</li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import nav from '@/mixins/nav.js'

export default {
  name: 'header-pc',

  mixins: [nav]
}
</script>

<style lang="scss" scoped>
.header-pc {
  height: 82px;
  line-height: 82px;
  background: #FFFFFF;

  .header-box {
    margin: 0 auto;
    width: $container-width;
    height: 100%;
    @include flex(row);

  .header-left {
    flex: 1;

    img {
      cursor: pointer;
    }
  }

  .header-right {
    flex: 1;
    text-align: right;

    ul {
      @include flex(row);
      list-style-type:none;

      li {
        margin-right: 77px;
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        cursor: pointer;
        user-select: none;

        &:hover {
          @extend .li--activated;
        }

        &:last-child {
          margin-right: 0;
        }
      }

      .li--activated {
        color: $base-color;
      }
    }
  }
  }
}
</style>
